import { computed, defineComponent, ref } from "@vue/composition-api";
import ApplicationStandalone from "@Client/@Modules/application-standalone/components/application-standalone.vue";
import ApplicationLayout from "@Client/@Modules/application-standalone/components/layout/application-layout.vue";
import ApplicationNavbar from "@Client/@Modules/application-standalone/components/application-navbar.vue";
import fullApplicationSidebar from "./full-application-sidebar.vue";
import * as AccountGetters from "@Client/@Modules/main/store/account/account-getters";
import * as AccountActions from "@Client/@Modules/main/store/account/account-actions";
import { useAccountStoreState, useAccountStoreGetters, useAccountStoreActions } from "@Client/@Modules/main/store/account/account-helpers";
import { useI18n } from "vue-i18n-composable";
import ApplicationQuickActions from "./application-quick-actions.vue";
import LockedApplicationBanner from "@Client/@Modules/banners/locked-application-banner.vue";
export default defineComponent({
  name: "ApplicationContainer",
  components: {
    ApplicationLayout,
    fullApplicationSidebar,
    ApplicationStandalone,
    ApplicationNavbar,
    ApplicationQuickActions,
    LockedApplicationBanner
  },
  setup(props, {
    emit
  }) {
    const {
      selectedApplicationId
    } = useAccountStoreState(["selectedApplicationId"]);
    const showSidebar = ref(true);
    const applicationId = computed(() => selectedApplicationId.value);
    const {
      locale
    } = useI18n();
    const {
      CURRENT_USER_DETAILS,
      ACCOUNT_SUBDOMAIN,
      EMAIL_VERIFIED
    } = useAccountStoreGetters([AccountGetters.CURRENT_USER_DETAILS, AccountGetters.ACCOUNT_SUBDOMAIN, AccountGetters.EMAIL_VERIFIED]);
    const {
      RESEND_CONFIRMATION_EMAIL
    } = useAccountStoreActions([AccountActions.RESEND_CONFIRMATION_EMAIL]);
    const currentStep = ref("");
    const applicationStandalone = ref();
    const invalidSteps = ref([]);
    const refresh = ref(false);
    const handleApplicationSubmitted = async () => {
      if (EMAIL_VERIFIED.value) return;
      await RESEND_CONFIRMATION_EMAIL({
        email: CURRENT_USER_DETAILS.value.email,
        currentSubdomain: ACCOUNT_SUBDOMAIN.value,
        locale: locale.value
      });
    };
    const handleInvalidStep = ({
      invalidPages
    }) => {
      invalidSteps.value = invalidPages;
    };
    const goNext = () => applicationStandalone.value.goNext();
    const goPrev = () => applicationStandalone.value.goPrev();
    const goEdit = page => applicationStandalone.value.goEdit(page);
    const toggleSidebar = () => {
      showSidebar.value = !showSidebar.value;
      emit("showSidebar", showSidebar);
    };
    const handleRefreshPage = () => {
      refresh.value = !refresh.value;
    };
    return {
      applicationId,
      handleApplicationSubmitted,
      currentStep,
      applicationStandalone,
      goNext,
      goPrev,
      goEdit,
      handleInvalidStep,
      invalidSteps,
      showSidebar,
      toggleSidebar,
      refresh,
      handleRefreshPage
    };
  }
});